/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const it_course_explorer_no_results = /** @type {(inputs: {}) => string} */ () => {
	return `Non abbiamo trovato risultati corrispondenti alla tua ricerca.`
};

const en_course_explorer_no_results = /** @type {(inputs: {}) => string} */ () => {
	return `We found no results matching your search.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "it" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_explorer_no_results = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_explorer_no_results(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_explorer_no_results", locale)
	if (locale === "it") return it_course_explorer_no_results(inputs)
	return en_course_explorer_no_results(inputs)
};
export { course_explorer_no_results as "course-explorer.no-results" }